(function () {
  'use strict';

  var FOCUSABLE = [
    'a[href]',
    'area[href]',
    'button',
    'input',
    'select',
    'textarea',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    'model-viewer',
    '[tabindex]',
    '[contenteditable="true"]'
  ].join(',');

  var STORE_ATTR = 'data-a11y-prev-tabindex';

  function isHidden(el) {
    return el.getAttribute('aria-hidden') === 'true';
  }

  function hiddenByAncestor(el) {
    for (var node = el.parentElement; node; node = node.parentElement) {
      if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
        return true;
      }
    }
    return false;
  }

  function disable(el) {
    if (!el.hasAttribute(STORE_ATTR)) {
      el.setAttribute(STORE_ATTR, el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
    }
    el.setAttribute('tabindex', '-1');
  }

  function restore(el) {
    if (!el.hasAttribute(STORE_ATTR)) {
      return;
    }
    var previous = el.getAttribute(STORE_ATTR);
    if (previous === '') {
      el.removeAttribute('tabindex');
    } else {
      el.setAttribute('tabindex', previous);
    }
    el.removeAttribute(STORE_ATTR);
  }

  function sync(container) {
    var hidden = isHidden(container);
    var focusables = container.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < focusables.length; i++) {
      var el = focusables[i];
      if (hidden) {
        disable(el);
      } else if (!hiddenByAncestor(el)) {
        restore(el);
      }
    }
  }

  function scan(root) {
    var containers = root.querySelectorAll('[aria-hidden="true"]');
    for (var i = 0; i < containers.length; i++) {
      sync(containers[i]);
    }
  }

  function handleAddedNode(node) {
    if (node.nodeType !== 1) {
      return;
    }
    if (isHidden(node)) {
      sync(node);
      return;
    }
    if (typeof node.closest === 'function') {
      var container = node.closest('[aria-hidden="true"]');
      if (container) {
        sync(container);
      }
    }
  }

  function start() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'attributes') {
          sync(mutation.target);
        } else if (mutation.type === 'childList') {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            handleAddedNode(mutation.addedNodes[j]);
          }
        }
      }
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
